import { render } from "./MeetingDetail.vue?vue&type=template&id=7668cd38&scoped=true"
import script from "./MeetingDetail.vue?vue&type=script&lang=js"
export * from "./MeetingDetail.vue?vue&type=script&lang=js"

import "./MeetingDetail.vue?vue&type=style&index=0&id=7668cd38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7668cd38"]])

export default __exports__